import { TableCollapse, TableCellCollapse } from '@economist/design-system/dist/umd/common';
import * as React from 'react';
export default {
  TableCollapse,
  TableCellCollapse,
  React
};